import "../App.css"
import { useState, useEffect } from "react";
import ReactEcharts from "echarts-for-react";

const Analysis66 = () => {
    const [chartData, setChartData] = useState({});
    const [membershipTypes, setMembershipTypes] = useState([]);
    const [revenueContribution, setRevenueContribution] = useState([]);
    const [membershipTypesData, setMembershipTypesData] = useState([]);

    useEffect(() => {
        fetch("https://s3.eu-west-2.amazonaws.com/gym66.assets/summary.json")
            .then((response) => response.json())
            .then((data) => {
                //replace all occurences of Unlimited Class with Unlimited in data.results.types.type
                data.results.forEach((entry) => {
                    entry.types.forEach((type) => {
                        if (type.type === "Unlimited Class") {
                            type.type = "Unlimited";
                        }
                    });
                });

                setChartData(data);
                if (data.results && data.results.length > 0) {

                    let membershipTypesData = [];
                    for (let j = 0; j < data.results.length; j++) {
                        let thisSet = data.results[j];
                        //get unique membership types and count the number of occurrences of each type
                        let typesCount = {};
                        thisSet.types.forEach((type) => {
                            if (typesCount[type.type]) {
                                typesCount[type.type]++;
                            } else {
                                typesCount[type.type] = 1;
                            }
                        });
                        typesCount = Object.keys(typesCount).sort().reduce((obj, key) => {
                            obj[key] = typesCount[key];
                            return obj;
                        }, {});
                        typesCount.date = thisSet.sample_time;
                        membershipTypesData.push(typesCount);
                    }
                    setMembershipTypes(membershipTypesData[membershipTypesData.length - 1]);
                    setMembershipTypesData(membershipTypesData);
                    console.log(membershipTypesData);

                    setRevenueContribution([]);
                    let contributions = [];
                    for (let i = 0; i < data.results.length; i++) {
                        let entry = data.results[i];
                        //get revenue contribution for each type
                        let revenueByType = {};

                        entry.types.forEach((type) => {
                            if (revenueByType[type.type]) {
                                revenueByType[type.type] += type.value;
                            } else {
                                revenueByType[type.type] = type.value;
                            }
                        });
                        revenueByType.date = entry.sample_time;
                        contributions.push(revenueByType);
                    }

                    setRevenueContribution(contributions);
                    console.log(contributions);
                }
            })
            .catch((error) => console.error("Error fetching data:", error));
    }, [chartData.last_update]);

    const membershipsOptions = {
        title: {
            text: "Memberships Over Time",
        },
        tooltip: {
            trigger: "axis",
            axisPointer: { type: "cross" },
        },
        xAxis: {
            type: "time",
        },
        yAxis: {
            type: "value",
            //zoom on y axis to fit data
            min: (value) => Math.floor(value.min - 5),
            max: (value) => Math.ceil(value.max + 5),
            name: "Memberships",
        },
        series: [
            {
                name: "Memberships",
                type: "line",
                data: chartData && chartData.results ? chartData.results.map(item => [item.sample_time, item.memberships]) : [],
            },
            // {
            //     name: "Clients",
            //     type: "line",
            //     data: chartData && chartData.results ? chartData.results.map(item => [item.sample_time, item.clients]) : [],
            // }
        ],
    };

    const stackedRevenueOptions = {
        title: {
            text: "Revenue Contributions Over Time",
        },
        tooltip: {
            trigger: "axis",
            axisPointer: { type: "cross" },
        },
        xAxis: {
            type: "time",
        },
        yAxis: {
            type: "value",
            name: "Revenue (£)"
        },
        series: revenueContribution && revenueContribution.length > 0 ? Object.keys(membershipTypes).map(type => ({
            name: type,
            type: "line",
            stack: "Total",
            areaStyle: {},
            emphasis: {
                focus: "series",
            },
            data: revenueContribution.map(entry => [entry.date, entry[type]]),
        })) : [],
    };

    const membershipTypesOptions = {
        title: {
            text: "Membership Types Pie Chart",
        },
        series: [
            {
                name: "Membership Types",
                type: "pie",
                radius: "70%",
                data: membershipTypes ? Object.keys(membershipTypes).map(key => ({ name: key, value: membershipTypes[key] })) : [],
                emphasis: {
                    itemStyle: {
                        shadowBlur: 10,
                        shadowOffsetX: 0,
                        shadowColor: "rgba(0, 0, 0, 0.5)",
                    },
                },
                label: { show: true, formatter: '{b}:\n{c}' },
            },
        ],
    };

    const membershipTypesOverTimeOptions = {
        title: {
            text: "Membership Types Over Time",
        },
        tooltip: {
            trigger: "axis",
            axisPointer: { type: "cross" },
        },
        xAxis: {
            type: "time",
        },
        yAxis: {
            type: "value",
            name: "Memberships",
        },
        series: membershipTypesData && membershipTypesData.length > 0 ? Object.keys(membershipTypesData[0]).map(type => ({
            name: type,
            type: "line",
            data: membershipTypesData.map(entry => [entry.date, entry[type]]),
        })) : [],
    };

    const predictRevenue = () => {
        if (!chartData.results || chartData.results.length === 0) return 0;
        const latestData = chartData.results[chartData.results.length - 1];
        let revenue = 0;
        //iterate through latestData.types
        for (let i = 0; i < latestData.types.length; i++) {
            const type = latestData.types[i];
            revenue += type.value;
        }
        return revenue;
    }

    return (
        <main style={{ padding: 20 }}>
            <h1>Gym 66 - Membership Analysis</h1>
            <p>Predicted Revenue: £{predictRevenue()}<br />Last update: {chartData.last_update ? new Date(chartData.last_update).toLocaleDateString() : "N/A"}</p>

            {chartData.results && (
                <ReactEcharts option={membershipsOptions} />
            )}
            {membershipTypes && (
                <ReactEcharts option={membershipTypesOptions} />
            )}
            {revenueContribution && (
                <ReactEcharts option={stackedRevenueOptions} />
            )}
            {membershipTypesOverTimeOptions && (
                <ReactEcharts option={membershipTypesOverTimeOptions} />
            )}
        </main>
    );
};

export default Analysis66;